<template>
    <div class="data-grid" ref="usergrid">
        <b-table :sticky-header="height"
                 :busy.sync="isBusy"
                 :items="filteredItems"
                 :fields="columnsfield"
                 :show-empty="showempty"
                 no-border-collapse
                 head-variant="head-border"
                 :per-page="perPage"
                 :current-page="currentPage"
                 @sort-changed="handleSortChange"
                 no-local-sorting="true"
                 :sort-direction="sortDirection"
                 :sort-desc.sync="sortDesc"
                 :sort-by.sync="sortBy">
            <template v-slot:table-busy>
                <div class="text-center">
                    <b-spinner class="align-middle gridSpinner"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>
            <template v-slot:head(remove)="data">
                <span title="Remove User">Remove</span>
            </template>

            <template slot="top-row" slot-scope="data" v-if="options">
                <td v-for="key in fieldKeys" :key="key" class="gridFilter" :class="key">
                    <v-select :options="options[key]" v-if="key!='isEnable' && key!='remove'" v-model="selectOption[key]" v-on:input="onFilterChange(key,$event)" class="form-control form-control-sm selectcontrol" append-to-body>
                        <template v-slot:option="option">
                            <span :title="option.label">
                                {{ option.label }}
                            </span>
                        </template>
                    </v-select>
                </td>


            </template>
            <template v-slot:cell(userName)="data">
                <b-button class="userListaddbtn"
                          v-on:click="createAdfsUser(data.item)"
                          v-if="(data.item.adfsGuid==null || data.item.adfsGuid=='') && (data.value==null || data.value=='') && (data.item.deactivated==false)" title="Click to create username">Create Username</b-button>
                <b-button class="userListaddbtn"
                          v-on:click="reactivateUser(data)"
                          v-if="(data.item.adfsGuid==null || data.item.adfsGuid=='') && (data.value==null || data.value=='')  && (data.item.deactivated==true)" title="Click to Reactivate">Reactivate</b-button>
                <div v-if="(data.item.adfsGuid!=null && data.item.adfsGuid!='') && (data.value==null || data.value=='')">
                    <b-spinner class="align-middle gridSpinner"></b-spinner>
                    <strong>Loading...</strong>
                </div>
                <a v-on:click="EditUser(data)" v-else class="link" :title="data.value">{{data.value}}</a>
            </template>
            <template v-slot:cell(firstName)="data">
                <span :title="data.value" v-bind:class="{'disable-text': data.item.deactivated}">{{data.value}}</span>
            </template>
            <template v-slot:cell(lastName)="data">
                <span :title="data.value" v-bind:class="{'disable-text': data.item.deactivated}">{{data.value}}</span>
            </template>
            <template v-slot:cell(email)="data">
                <span :title="data.value">{{data.value}}</span>
            </template>
            <template v-slot:cell(remove)="data">
                <span v-if="data.item.adfsGuid!=null && data.item.adfsGuid!='' && (!data.item.isStatusRetrived)">
                    <font-awesome-icon hidden="hidden" class="link" icon="user-times" v-on:click="remove(data)" />
                </span>
                <span title=" Click to remove user from account" v-else>
                    <font-awesome-icon class="link" icon="user-times" v-on:click="remove(data)" />
                </span>
            </template>
            <template v-slot:cell(isEnable)="data">
                <div v-if="data.item.adfsGuid!=null && data.item.adfsGuid!='' && (!data.item.isStatusRetrived)">
                    <b-spinner class="align-middle gridSpinner" title="Loading"></b-spinner>
                    <!--<strong>Loading...</strong>-->
                </div>
                <div v-else-if="((data.item.adfsGuid==null || data.item.adfsGuid=='' || data.item.adfsGuid=='undefined') && !data.item.isStatusRetrived)">
                    <span title="Disabled">
                        <font-awesome-icon icon="times-circle" class="svg-red" />
                    </span>
                </div>
                <div v-else>
                    <span v-if="(data.value == true )" title="Enabled">
                        <font-awesome-icon icon="check-circle" class="svg-green" />
                    </span>
                    <span v-else title="Disabled">
                        <font-awesome-icon icon="times-circle" class="svg-red" />
                    </span>
                </div>

            </template>
        </b-table>
        <div class="filteredActiveContact" v-if="!isBusy">
            <font-awesome-icon id="activeContactInfoIcon" icon="question-circle" class="svg-black" style="cursor:pointer;" />
            <font-awesome-icon style="cursor:pointer;"
                               :icon="srcAccount.hideInactiveContact? ['far','check-square'] :  ['far','square']"
                               :class="'mr-1 ml-1'"
                               :title="'Hide inactive contacts'"
                               v-on:click="filterActiveUsers()" />
            <span>Hide inactive contacts</span>

        </div>
        <div class="float-right pagging-margin" v-if="!isBusy">
            <span class="paginationCurrentPage mr-2 mt-1" v-if="rows>0">{{index+1}}-{{recordCount}} of {{rows}} Records</span>
            <span class="paginationCurrentPage mr-2 mt-1" v-if="rows==0">{{0}}-{{recordCount}} of {{rows}} Records</span>
            <b-pagination v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          aria-controls="AuditHistoryTable"
                          align="right"
                          size="sm"
                          v-on:input="pagingClickedEventhandler"></b-pagination>
        </div>
        <div>
            <b-modal id="RemoveUserPromptModal"
                     ref="RemoveUserPromptModal"
                     title="BootstrapVue"
                     class="modal-backdrop"
                     no-close-on-esc
                     no-close-on-backdrop
                     :no-enforce-focus="true">
                <template slot="modal-header">
                    <h5 class="modal-title">Confirmation</h5>
                </template>
                <template slot="default">
                    <p>{{ removemessage }}</p>
                </template>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button class="um-btn" @click="cancel()">Cancel</b-button>
                    <b-button class="um-btn" @click="ConfirmYesClick">Remove</b-button>
                </template>
            </b-modal>
        </div>
        <!-- v-if="Object.keys(editingUser).length > 0" -->
        <EditUser ref="editUser"
                  v-if="srcAccount != null && Object.keys(editingUser).length > 0"
                  :editingUserDetails="editingUser"
                  :srcAccount="srcAccount"
                  :userDetail="editingUser.userDetail"
                  @onUserUpdated="userUpdated" />
        <ToggleUserStatus :userDetail="userDetail"
                          :message="message"
                          :headerMessage="headerMessage"
                          :StatusButtonTxt="StatusButtonTxt"
                          :isValid="isValid"
                          @statusChanged="onStatusChanged" ref="toggelstatusModal"></ToggleUserStatus>
        <InfoPopup :popupmessage="info.message" :title="info.title" ref="InfoModel"></InfoPopup>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
        <b-tooltip target="activeContactInfoIcon" v-if="!isBusy" triggers="hover" placement="top" style="background-color:red !important;">
            Filter individuals who are no longer affiliated with NiCE CXone Mpower from the list.
        </b-tooltip>
    </div>
</template>

<script>
    import EditUser from "./../EditUser";
    import Loading from "vue-loading-overlay";
    import service from "../../services/api.services";
    import { eventbus } from "../../main";
    import enviromentVariable from '../../constants/enviromentVariable';
    import InfoPopup from "./InfoPopup";
    import ToggleUserStatus from "./ToggleUserStatus";

    export default {
        name: "datagrid",
        components: {
            Loading,
            EditUser,
            InfoPopup,
            ToggleUserStatus
        },
        props: {
            users: Array,
            isBusy: Boolean,
            srcAccount: Object,
            freshLoad: Boolean
        },
        data: function () {
            return {
                perPage: enviromentVariable.perPage,
                currentPage: 1,
                editingUser: {},
                isLoading: false,
                fullPage: true,
                showempty: true,
                height: "",
                breakTheLoop: false,
                isUserNameUpdated: false,
                userList: this.users,
                defaultOption_All: "[All]",
                defaultOption_Blanks: "[Blanks]",
                removemessage: "",
                selectOption: {
                    userName: "[All]",
                    isEnable: "[All]",
                    firstName: "[All]",
                    lastName: "[All]",
                    email: "[All]",
                    remove: "[All]"

                },
                info: {
                    message: "",
                    title: ""
                },
                filteredKeys: [],
                selectedKey: '',
                pagedcontactListwithUserName: [],
                skip: 0,
                sortBy: "firstName",
                sortDesc: false,
                sortDirection: "asc",
                removeData: {},
                user_name: this.$store.getters.username,
                allAccounts: [],
                userDetail: {},
                message: "The user cannot be removed from this Account because it is designated as the Primary Account. Continuing will deactivate the contact and disable access to the Customer Community and Support Site." +
                    "Deactivated contacts can be reactivated and re-enabled later by clicking their username and clicking the toggle on Global User Status if needed.",
                headerMessage: "Information",
                StatusButtonTxt: "Deactivate Contact",
                index: 0,
                fullUsersList: [],
                activeUsersList: [],
                isFlagUpdated: false
            };
        },

        created() {
            window.addEventListener("resize", this.handleHeightResize);
        },
        destroyed() {
            window.removeEventListener("resize", this.handleHeightResize);
        },
        mounted() {
            var that = this;
            eventbus.$on("setAddedUser", function (data) {
                that.isUserNameUpdated = false
                that.users.forEach(function (user) {
                    if (user.sfContactId == data.sfContactId) {
                        user.userName = data.userName;
                        user.firstName = data.firstName;
                        user.adfsGuid = data.adfsGuid;
                        that.isUserNameUpdated = true;
                        user.isEnable = data.isEnable;
                        user.isStatusRetrived = true;
                    }
                });
                if (that.isUserNameUpdated == false)
                    that.users.push(data);

                that.resetUsersList(data, that.users);


            });
            this.handleHeightResize();
            eventbus.$on("onAccountRemovalUpdateUserList", function (sfContactId, sfAccountId) {
                var userObj = that.users.find(x => x.sfContactId === sfContactId && (sfAccountId == null || x.sfAccountId === sfAccountId));
                that.users.splice(that.users.indexOf(userObj), 1);
                that.resetUsersList(userObj, that.users);
                that.GetContactsWithUserNames();
                if (
                    that.pagedcontactListwithUserName != null &&
                    that.pagedcontactListwithUserName.length > 0
                ) {
                    that.GetUserStatusByUserName(that.pagedcontactListwithUserName)
                }
            });
            eventbus.$on("confirmOkChanges", function () {
                that.okChanges();
            });
        },
        computed: {
            columnsfield: function () {
                var fields = [
                    {
                        key: "userName",
                        tdClass: ["th-td-min-width", "cell-ellipsis td_username"],
                        thClass: ["th-td-min-width  td_username col-3", "usergrid-thClass"],
                        sortable: true
                    },
                    {
                        key: "isEnable",
                        label: "Enabled",
                        tdClass: "th-td-enabled td_Deactivated",
                        thClass: ["th-td-enabled  td_Deactivated  col-1", "usergrid-thClass"],
                        sortable: false
                    },
                    {
                        key: "firstName",
                        tdClass: ["th-td-min-width", "cell-ellipsis td_firstname"],
                        thClass: ["th-td-min-width  td_firstname  col-2", "usergrid-thClass"],
                        sortable: true
                    },
                    {
                        key: "lastName",
                        tdClass: ["th-td-min-width", "cell-ellipsis td_lastname"],
                        thClass: ["th-td-min-width td_lastname  col-2", "usergrid-thClass"],
                        sortable: true
                    },
                    {
                        key: "email",
                        tdClass: ["th-td-min-width", "cell-ellipsis td_email"],
                        thClass: ["th-td-min-width col-4 td_email", "usergrid-thClass"],
                        sortable: true
                    },
                    {
                        key: "remove",
                        label: "Remove",
                        tdClass: "th-td-enabled td_Deactivated",
                        thClass: ["th-td-enabled  td_Deactivated  col-1", "usergrid-thClass"],
                        sortable: false
                    },
                    {
                        key: "sfAccountId",
                        tdClass: "display-none",
                        thClass: "display-none"
                    },
                    {
                        key: "sfContactId",
                        tdClass: "display-none",
                        thClass: "display-none"
                    },
                    {
                        key: "adfsGuid",
                        tdClass: "display-none",
                        thClass: "display-none"
                    },
                    {
                        key: "isStatusRetrived",
                        tdClass: "display-none",
                        thClass: "display-none"
                    },
                    {
                        key: "deactivated",
                        tdClass: "display-none",
                        thClass: "display-none"
                    },
                    {
                        key: "isPrimary",
                        tdClass: "display-none",
                        thClass: "display-none"
                    },
                    {
                        key: "isLocked",
                        tdClass: "display-none",
                        thClass: "display-none"
                    }
                ];
                return fields;
            },
            rows() {
                return (this.filteredItems != "undefined" && this.filteredItems != null) ? this.filteredItems.length : 0;
            },
            recordCount() {
                var that = this;
                if (that.filteredItems != "undefined" && that.filteredItems != null && that.filteredItems.length < (that.perPage + that.skip)) {
                    return that.filteredItems.length;
                }
                else {
                    return that.perPage + that.skip;
                }
            },

            filteredItems() {
                if (this.users != null) {
                    return this.users.filter(item => {
                        let keep = true;
                        this.fieldKeys.forEach(key => {
                            if (this.selectOption[key] != null) {
                                if (this.selectOption[key] === "[Blanks]")
                                    keep = keep && (item[key] === undefined || item[key] === null || item[key] === "");
                                else
                                    keep = keep && (this.selectOption[key] === "[All]" || item[key] === this.selectOption[key]);
                            }
                        });
                        return keep;
                    });
                }
            },
            fieldKeys() {
                return Object.keys(this.selectOption)
            },
            options() {
                var options = {};
                if (this.filteredItems != null) {
                    var isFiltered = false
                    this.fieldKeys.forEach(key => {
                        var dataToFilter = []
                        if (this.filteredKeys.length == 0) {
                            dataToFilter = this.users
                        }
                        else if (this.filteredKeys.includes(key) && !isFiltered && this.filteredKeys.length == 1) {
                            dataToFilter = this.users
                            isFiltered = true;
                        }
                        else {
                            dataToFilter = this.filteredItems
                        }

                        var vals = dataToFilter.map(item => {
                            if (item[key] == null || typeof item[key] == "undefined")
                                return ""
                            else
                                return item[key]
                        });

                        var includeBlankOption = false;

                        var values = Array.from(new Set(vals));
                        if (values.includes(undefined) || values.includes(''))
                            includeBlankOption = true;
                        values = values.filter(function (element) {
                            return element !== undefined && element !== null && element !== ''
                        });
                        options[key] = values.sort(function (a, b) {
                            return String(a).toLowerCase().localeCompare(String(b).toLowerCase());
                        });
                        if (includeBlankOption)
                            options[key].unshift(this.defaultOption_Blanks);

                        options[key].unshift(this.defaultOption_All);

                    });
                }
                return options;
            }
        },
        watch: {
            users: function (newVal) {
                var that = this;
                if (newVal != "undefined" && newVal != null) {
                    if (that.freshLoad) {
                        that.fullUsersList = [];
                        that.users = that.resetUsersList(null, newVal);
                        that.freshLoad = false;
                    }
                }
            }
        },
        methods: {
            async EditUser(user) {
                this.breakTheLoop = true;
                var that = this;
                this.isLoading = true;
                await service
                    .GetEditingUserDetails(user.item.sfAccountId, user.item.sfContactId)
                    .then(response => {
                        that.editingUser = response.data;
                        that.isLoading = false;

                        setTimeout(() => {
                            that.$bvModal.show("editUserModel");
                        }, 10);

                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    });
            },
            userUpdated: function (user, updateStatus) {
                this.users.forEach(function (u) {
                    if (u.userName != null && u.email != null && u.userName.toLowerCase() == user.userName.toLowerCase() && u.email.toLowerCase() == user.email.toLowerCase()) {
                        u.firstName = user.firstName;
                        u.lastName = user.lastName;
                        if (updateStatus) {
                            u.deactivated = user.deactivated;
                            u.isEnable = user.isEnable;
                        }
                    }
                });
                if (updateStatus) {
                    this.fullUsersList.forEach(function (u) {
                        if (u.userName != null && u.email != null && u.userName.toLowerCase() == user.userName.toLowerCase() && u.email.toLowerCase() == user.email.toLowerCase()) {
                            u.deactivated = user.deactivated;
                            u.isEnable = user.isEnable;
                        }
                    });
                    this.users = this.resetUsersList(null, this.users, true);
                }
                this.GetContactsWithUserNames();
                if (
                    this.pagedcontactListwithUserName != null &&
                    this.pagedcontactListwithUserName.length > 0
                ) {
                    this.GetUserStatusByUserName(this.pagedcontactListwithUserName)
                }
            },
            pagingClickedEventhandler: function () {
                var that = this;
                that.GetContactsWithUserNames();
                if (
                    that.pagedcontactListwithUserName != null &&
                    that.pagedcontactListwithUserName.length > 0
                ) {
                    that.GetUserStatusByUserName(that.pagedcontactListwithUserName)
                }
            },
            handleSortChange: function (e) {
                this.sortBy = e.sortBy;
                this.sortDesc = e.sortDesc;
                this.updateFilterdDataForSorting();
                this.GetContactsWithUserNames();
                if (
                    this.pagedcontactListwithUserName != null &&
                    this.pagedcontactListwithUserName.length > 0
                ) {
                    this.GetUserStatusByUserName(this.pagedcontactListwithUserName)
                }
            },
            clear: function () {
                this.info.message = "";
                this.info.title = "";
                this.removemessage = "";
                this.isLoading = false;
                this.removeData = {};
            },
            reactivateUser: function (data) {
                var that = this;
                if (!this.$store.getters.isImpersonation) {
                    that.clear();
                    if ((data.item.adfsGuid == "" || data.item.adfsGuid == null) && (data.item.deactivated == true)) {
                        that.message = "This action will reactivate the user's profile";
                        that.StatusButtonTxt = "Reactivate";
                        that.$refs.toggelstatusModal.isEnabled = false
                        that.userDetail = that.prepareUserDetailObj(data.item, false);
                        that.$refs.toggelstatusModal.$refs["toggleUserStatusModal"].show()
                    }
                }
                else {
                    that.info.title = "Information Message";
                    that.info.message = "This action is not allowed while impersonating";
                    that.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }

            },
            remove: function (data) {
                var that = this;
                if (!this.$store.getters.isImpersonation) {
                    that.clear();
                    that.removeData = data.item;
                    that.GetUserAccounts(data.item.email, data.item);
                }
                else {
                    that.info.title = "Information Message";
                    that.info.message = "This action is not allowed while impersonating";
                    that.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            },
            GetUserAccounts: function (email, rowData) {
                var that = this;
                that.allAccounts = [];
                that.isLoading = true;
                service
                    .GetUserAccountsByEmailId(email)
                    .then(
                        data => {
                            if (data != null && data.data != null && data.data.length > 0) {
                                that.isLoading = false;
                                that.allAccounts = data.data;
                                if (that.allAccounts.length == 1 && that.allAccounts[0].isPrimaryAccount) {
                                    that.StatusButtonTxt = "Deactivate Contact";
                                    that.$refs.toggelstatusModal.isEnabled = true
                                    that.userDetail = that.prepareUserDetailObj(rowData, true);
                                    if (rowData.adfsGuid != null && rowData.adfsGuid != "") {
                                        if (!rowData.isEnable) {
                                            that.info.message = "The user cannot be removed from this Account because it is designated as the Primary Account. The user is inactive and access to the Customer Community and Support Site is disabled. If you want to remove the user from your view, check the Hide inactive user's box."
                                                + "Click on the username to reactivate and re-enable the user.";
                                            that.info.title = "Information Message";
                                            that.$bvModal.show("infopopup");
                                        }
                                        else {
                                            that.message = "The user cannot be removed from this Account because it is designated as the Primary Account. Continuing will deactivate the contact and disable access to the Customer Community and Support Site." +
                                                "Deactivated contacts can be reactivated and re-enabled later by clicking their username and clicking the toggle on Global User Status if needed."

                                            that.$refs.toggelstatusModal.$refs["toggleUserStatusModal"].show()
                                        }
                                    }
                                    else {
                                        if (rowData.deactivated) {
                                            that.info.message = "The user cannot be removed from this Account because it is designated as the Primary Account. The user is inactive and has no access to the Customer Community or Support Site. If you want to remove the user from your view, check the Hide inactive user's box. The user can be reactivated later by clicking the Reactivate button next to their name.";
                                            that.info.title = "Information Message";
                                            that.$bvModal.show("infopopup");
                                        }
                                        else {
                                            that.message = "The user cannot be removed from this Account because it is designated as the Primary Account." +
                                                "Continuing will deactivate the contact. Deactivated contacts can be reactivated and re-enabled later if needed.";
                                            that.$refs.toggelstatusModal.$refs["toggleUserStatusModal"].show()
                                        }
                                    }
                                }
                                else {
                                    if (that.checkforPrimeryAccount(rowData.isPrimary)) {
                                        that.$bvModal.show("infopopup");
                                    } else {
                                        that.$bvModal.show("RemoveUserPromptModal");
                                    }
                                }
                            }
                        },
                        error => {
                            that.isLoading = false;
                            console.log(error);
                            that.allAccounts = [];
                        }
                    );
            },
            onStatusChanged(value) {
                var that = this;
                if (this.userDetail != null && this.userDetail != "" && this.userDetail.sfContactId != "" && this.userDetail.sfContactId != null) {
                    this.users.forEach(function (u) {
                        if (u.sfContactId == that.userDetail.sfContactId) {
                            u.deactivated = !value;
                            u.isEnable = value;
                            console.log("u.deactivated", u)                         
                        }
                    });
                    this.fullUsersList.forEach(function (u) {
                        if (u.sfContactId == that.userDetail.sfContactId) {
                            u.deactivated = !value;
                            u.isEnable = value;
                            console.log("u.deactivated", u.deactivated)                         
                        }
                    });
                    that.users = that.resetUsersList(null, that.users, true);
                    that.GetContactsWithUserNames();
                    if (
                        that.pagedcontactListwithUserName != null &&
                        that.pagedcontactListwithUserName.length > 0
                    ) {
                        that.GetUserStatusByUserName(that.pagedcontactListwithUserName)
                    }
                }
            },

            prepareUserDetailObj(data, enabled) {
                return {
                    userName: data.userName,
                    sfContactId: data.sfContactId,
                    adfsGuid: data.adfsGuid,
                    isLocked: data.isLocked,
                    sfAccountId: data.sfAccountId,
                    enabled: enabled
                };
            },
            checkforPrimeryAccount: function (isDirect) {
                var isPrimery = false;
                if (isDirect) {

                    this.info.message =
                        "This is the primary account, account = " +
                        this.srcAccount.accountName + " for this user" +
                        ".In order to remove the user from this account, please contact your Support representative to request the Primary designation be changed to a different account.";
                    this.info.title = "Error";
                    isPrimery = isDirect;
                } else {
                    this.removemessage =
                        "This request will remove the user association to account " +
                        this.srcAccount.accountName;
                    isPrimery = isDirect;
                }
                return isPrimery;
            },
            ConfirmYesClick: function () {
                this.$refs["RemoveUserPromptModal"].hide();
                this.confirmRemove();
            },
            okChanges: function () {
                this.$bvModal.hide("infopopup");
                this.clear();
            },
            confirmRemove: function () {
                var that = this;
                that.isLoading = true;
                if (that.removeData != '' && that.removeData != "undefined" && that.removeData != null)
                    var userdetailObject = {
                        SFAccountId: that.removeData.sfAccountId,
                        SFContactId: that.removeData.sfContactId,
                        LoggedInUserName: that.user_name,
                        AccountNumber: that.srcAccount.accountNumber,
                        adfsGuid: that.removeData.adfsGuid
                    };
                service
                    .RemoveAccount(userdetailObject)
                    .then(data => {
                        if (data.status == "200") {
                            eventbus.$emit("onAccountRemovalUpdateUserList", that.removeData.sfContactId, that.removeData.sfAccountId);

                            that.clear();
                        }
                    })
                    .catch(error => {
                        console.log("api error:" + error);
                    });
            },

            updateFilterdDataForSorting: function () {
                if (this.sortBy == "lastName") {
                    if (!this.sortDesc) {
                        this.users.sort(function (a, b) {
                            return (typeof a.lastName == "undefined" || a.lastName == null || a.lastName == "") ? -1
                                : (typeof b.lastName == "undefined" || b.lastName == null || b.lastName == "") ? 1
                                    : (a.lastName.toLowerCase() < b.lastName.toLowerCase()) ? -1
                                        : (a.lastName.toLowerCase() > b.lastName.toLowerCase()) ? 1 : 0
                        });
                    }
                    else {
                        this.users.sort(function (a, b) {
                            return (typeof a.lastName == "undefined" || a.lastName == null || a.lastName == "") ? -1
                                : (typeof b.lastName == "undefined" || b.lastName == null || b.lastName == "") ? 1
                                    : (a.lastName.toLowerCase() > b.lastName.toLowerCase()) ? -1
                                        : (a.lastName.toLowerCase() < b.lastName.toLowerCase()) ? 1 : 0
                        });
                    }
                }
                if (this.sortBy == "firstName") {
                    if (!this.sortDesc) {
                        this.users.sort(function (a, b) {
                            return (typeof a.firstName == "undefined" || a.firstName == null || a.firstName == "") ? -1
                                : (typeof b.firstName == "undefined" || b.firstName == null || b.firstName == "") ? 1
                                    : (a.firstName.toLowerCase() < b.firstName.toLowerCase()) ? -1
                                        : (a.firstName.toLowerCase() > b.firstName.toLowerCase()) ? 1 : 0
                        });
                    }
                    else {
                        this.users.sort(function (a, b) {
                            return (typeof a.firstName == "undefined" || a.firstName == null || a.firstName == "") ? -1
                                : (typeof b.firstName == "undefined" || b.firstName == null || b.firstName == "") ? 1
                                    : (a.firstName.toLowerCase() > b.firstName.toLowerCase()) ? -1
                                        : (a.firstName.toLowerCase() < b.firstName.toLowerCase()) ? 1 : 0
                        });
                    }
                }
                if (this.sortBy == "userName") {
                    if (!this.sortDesc) {
                        this.users.sort(function (a, b) {
                            return (typeof a.userName == "undefined" || a.userName == null || a.userName == "") ? -1
                                : (typeof b.userName == "undefined" || b.userName == null || b.userName == "") ? 1
                                    : (a.userName.toLowerCase() < b.userName.toLowerCase()) ? -1
                                        : (a.userName.toLowerCase() > b.userName.toLowerCase()) ? 1 : 0
                        });
                    }
                    else {
                        this.users.sort(function (a, b) {
                            return (typeof a.userName == "undefined" || a.userName == null || a.userName == "") ? -1
                                : (typeof b.userName == "undefined" || b.userName == null || b.userName == "") ? 1
                                    : (a.userName.toLowerCase() > b.userName.toLowerCase()) ? -1
                                        : (a.userName.toLowerCase() < b.userName.toLowerCase()) ? 1 : 0
                        });
                    }
                }
                if (this.sortBy == "email") {
                    if (!this.sortDesc) {
                        this.users.sort(function (a, b) {
                            return (typeof a.email == "undefined" || a.email == null || a.email == "") ? -1
                                : (typeof b.email == "undefined" || b.email == null || b.email == "") ? 1
                                    : (a.email.toLowerCase() < b.email.toLowerCase()) ? -1
                                        : (a.email.toLowerCase() > b.email.toLowerCase()) ? 1 : 0
                        });
                    }
                    else {
                        this.users.sort(function (a, b) {
                            return (typeof a.email == "undefined" || a.email == null || a.email == "") ? -1
                                : (typeof b.email == "undefined" || b.email == null || b.email == "") ? 1
                                    : (a.email.toLowerCase() > b.email.toLowerCase()) ? -1
                                        : (a.email.toLowerCase() < b.email.toLowerCase()) ? 1 : 0
                        });
                    }
                }
            },
            GetContactsWithUserNames: function () {
                var that = this;
                var pagingRecords = [];
                that.pagedcontactListwithUserName = [];
                that.skip = (that.currentPage - 1) * that.perPage;
                that.index = that.skip;
                if (that.filteredItems.length < (that.perPage + that.skip)) {
                    that.recordCount = that.filteredItems.length
                    pagingRecords = that.filteredItems.slice(that.skip, that.recordCount);
                }
                else {
                    that.recordCount = that.perPage + that.skip;
                    pagingRecords = that.filteredItems.slice(that.skip, that.recordCount);
                }
                if (pagingRecords != "undefined" && pagingRecords != null && pagingRecords != "")
                    pagingRecords.forEach(function (key) {
                        if (
                            typeof key != "undefined" &&
                            (key.userName != null && key.userName != "") && !key.isStatusRetrived &&
                            key.adfsGuid != null &&
                            key.adfsGuid != ""
                        ) {
                            that.pagedcontactListwithUserName.push(key);
                        }
                    });
                //that.currentPage = 1;
            },
            handleHeightResize() {
                this.height =
                    window.innerHeight -
                    this.$refs.usergrid.getBoundingClientRect().top -
                    50 +
                    "px";
            },
            fixFilterWidth() {

            },
            async createAdfsUser(data) {
                var that = this;
                that.breakTheLoop = true;
                that.isLoading = true;
                await service
                    .GetContactByContactId(data.sfContactId)
                    .then(response => {
                        that.isLoading = false;
                        if (response.data != null && response.data.deactivated)
                            eventbus.$emit("OnDeactivatedContact");
                        else eventbus.$emit("OnUserListAddUser", response.data);
                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    });
            },

            async GetUserNameByAdfs(data) {
                var that = this;
                for (let i = 0; i < data.length; i++) {
                    if (typeof data[i] !== "undefined" && typeof data[i].adfsGuid !== "undefined" && data[i].adfsGuid != null && data[i].adfsGuid != "") {
                        const response = await service.UpdateContactDetailsIfAdfsGuidExists(data[i]);
                        var index = that.users.findIndex(x => x.adfsGuid === data[i].adfsGuid);
                        if (index > 0) {
                            if (
                                response != null &&
                                response.data != null &&
                                response.data.result != "" && response.data.result != null
                            ) {
                                that.users[index].userName = response.data.result.userName;
                                that.users[index].isEnable = response.data.result.enabled;
                                that.users[index].isStatusRetrived = true;
                            } else {
                                that.users[index].adfsGuid = "";
                                that.users[index].userName = "";
                                that.users[index].isStatusRetrived = true;
                            }
                        }
                    }
                }
            },
            async GetUserStatusByUserName(data) {
                var that = this;
                var userNameList = [];
                var notExistUsers = [];
                for (let i = 0; i < data.length; i++) {
                    if (typeof data[i] !== "undefined" && typeof data[i].adfsGuid !== "undefined" && data[i].adfsGuid != null && data[i].adfsGuid != "") {
                        userNameList.push(data[i].userName);
                    }
                }
                if (userNameList !== "undefined" && userNameList != null && userNameList != "") {
                    const response = await service.GetAdfsUserStatusByUserNames(userNameList);
                    if (
                        response != null &&
                        response.data != null &&
                        response.data.userDetail != "" && response.data.userDetail != null
                    )
                        for (let i = 0; i < response.data.userDetail.length; i++) {
                            var index = that.users.findIndex(x => x.adfsGuid === response.data.userDetail[i].adfsGuid);
                            if (index >= 0) {
                                if (response.data.userDetail[i] != "" && response.data.userDetail[i] != null) {
                                    that.users[index].isEnable = response.data.userDetail[i].enabled;
                                    that.users[index].isStatusRetrived = true;
                                    that.users[index].isLocked = response.data.userDetail[i].isLocked;
                                } else {
                                    that.users[index].adfsGuid = "";
                                    that.users[index].userName = "";
                                    that.users[index].isStatusRetrived = false;
                                }
                            }
                        } if (data.length != response.length) {
                            for (let i = 0; i < data.length; i++) {
                                var keep = response.data.userDetail.findIndex(x => x.adfsGuid === data[i].adfsGuid);
                                if (keep == -1) {
                                    notExistUsers.push(data[i])
                                }
                            }
                        }
                    if (notExistUsers.length != 0) {
                        for (let i = 0; i < notExistUsers.length; i++) {
                            var dataIndex = that.users.findIndex(x => x.adfsGuid === notExistUsers[i].adfsGuid);
                            if (dataIndex >= 0) {
                                that.users[dataIndex].isStatusRetrived = true;
                            }
                        }
                    }
                }
            },
            GetUserNameByAdfsGuid: function (key) {
                var that = this;
                service
                    .UpdateContactDetailsIfAdfsGuidExists(key)
                    .then(response => {
                        var index = that.users.findIndex(x => x.adfsGuid === key.adfsGuid);
                        if (index > 0) {
                            if (
                                response != null &&
                                response.data != null &&
                                response.data.result != ""
                            ) {
                                that.users[index].userName = response.data.result;
                            } else {
                                that.users[index].adfsGuid = "";
                                that.users[index].userName = "";
                            }
                        }
                    })
                    .catch(error => {
                        console.log("api error:" + error);
                    });
            },

            resetFilteredOption: function () {
                this.selectOption["userName"] = this.defaultOption_All
                this.selectOption["deactivated"] = this.defaultOption_All
                this.selectOption["firstName"] = this.defaultOption_All
                this.selectOption["lastName"] = this.defaultOption_All
                this.selectOption["email"] = this.defaultOption_All

                this.filteredKeys = []
                this.selectedKey = ''
            },
            resetPagingOptions: function () {
                this.currentPage = 1;
                this.skip = 0;
                this.sortDesc = false;
                this.sortBy = "firstName";
                this.sortDirection = "asc";
                this.index = 0;
            },

            onFilterChange: function (key, value) {
                this.selectedKey = key
                if (this.filteredKeys.includes(key) && value === this.defaultOption_All) {
                    const index = this.filteredKeys.indexOf(key);
                    if (index > -1)
                        this.filteredKeys.splice(index, 1);
                }
                else {
                    if (!this.filteredKeys.includes(key))
                        this.filteredKeys.push(key)
                }
                this.GetContactsWithUserNames();
                if (
                    this.pagedcontactListwithUserName != null &&
                    this.pagedcontactListwithUserName.length > 0
                ) {
                    this.GetUserStatusByUserName(this.pagedcontactListwithUserName)
                }
            },

            filterActiveUsers: function () {
                var that = this;
                if (!this.$store.getters.isImpersonation) {

                    that.srcAccount.hideInactiveContact = !that.srcAccount.hideInactiveContact;
                    if (that.srcAccount.hideInactiveContact)
                        that.users = that.activeUsersList;
                    else
                        that.users = that.fullUsersList;

                    service
                        .SetUserManagementAppSetting(that.srcAccount, that.$store.getters.loggedInUserAdfsGuid)
                        .then(response => {
                            if (response != null && response.data != null)
                                that.isFlagUpdated = response.data.isSuccess;
                        })
                        .catch(error => {
                            console.log("api error:" + error);
                        });

                    //Functionality to reset localStorage
                    var data = localStorage.getItem(this.$store.getters.username);
                    if (data) {
                        var accountData = JSON.parse(data);
                        if (accountData != "undefined" && accountData.length == "undefined" && (accountData.accountNumber == that.srcAccount.accountNumber)) {
                            accountData.hideInactiveContact = that.srcAccount.hideInactiveContact;
                        }
                        else {
                            var obj = accountData.find(x => x.accountNumber === that.srcAccount.accountNumber);
                            if (obj != "undefined" && obj != null)
                                obj.hideInactiveContact = that.srcAccount.hideInactiveContact;
                        }
                        localStorage.setItem(this.$store.getters.username, JSON.stringify(accountData));
                        that.GetContactsWithUserNames();
                        if (
                            that.pagedcontactListwithUserName != null &&
                            that.pagedcontactListwithUserName.length > 0
                        ) {
                            that.GetUserStatusByUserName(that.pagedcontactListwithUserName)
                        }
                    }

                    //update Account object
                    eventbus.$emit("UpdateHideInactiveContactFlag", that.srcAccount);
                }
                else {
                    that.info.title = "Information Message";
                    that.info.message = "This action is not allowed while impersonating";
                    that.$refs.InfoModel.$refs["InfoPopupModel"].show();
                }
            },

            resetUsersList: function (obj, updatedUserList, IsStatuUpdate = false) {
                var that = this;
                that.activeUsersList = [];
                if (obj != "undefined" && obj != null && updatedUserList != "undefined" && updatedUserList != null && updatedUserList.length > 0) {
                    var index = updatedUserList.indexOf(updatedUserList.find(x => x.sfContactId === obj.sfContactId));
                    var fullUsersListIndex = that.fullUsersList.indexOf(that.fullUsersList.find(x => x.sfContactId === obj.sfContactId))
                    if (index != -1 && fullUsersListIndex == -1) {
                        obj.deactivated = false;
                        that.fullUsersList.push(obj);
                    }
                    else if (index != -1 && fullUsersListIndex != -1)
                        that.fullUsersList[fullUsersListIndex] = obj;
                    else if (index == -1 && fullUsersListIndex != -1)
                        that.fullUsersList.splice(fullUsersListIndex, 1);
                }
                else {
                    if (updatedUserList != "undefined" && updatedUserList != null && updatedUserList.length > 0) {
                        if (!IsStatuUpdate) {
                            updatedUserList.forEach(function (key) {
                                that.fullUsersList.push(key);
                            });
                        }
                    }
                    else
                        that.fullUsersList = [];
                }

                if (that.fullUsersList != "undefined" && that.fullUsersList != null && that.fullUsersList.length > 0) {
                    that.fullUsersList.sort(function (a, b) {
                        return (typeof a.firstName == "undefined" || a.firstName == null || a.firstName == "") ? -1
                            : (typeof b.firstName == "undefined" || b.firstName == null || b.firstName == "") ? 1
                                : (a.firstName.toLowerCase() < b.firstName.toLowerCase()) ? -1
                                    : (a.firstName.toLowerCase() > b.firstName.toLowerCase()) ? 1 : 0
                    });

                    //Set Active Users
                    that.fullUsersList.forEach(function (key) {
                        if (key != "undefined" && key.deactivated != null && !key.deactivated)
                            that.activeUsersList.push(key);
                    });
                }

                if (that.srcAccount.hideInactiveContact)
                    return that.activeUsersList;

                else
                    return that.fullUsersList;
            }
        }
    };
</script>

